<template>
  <div id="timeline-info-bar">
    <template v-if="$_singlySelectedTimelineSegment !== undefined">
      <template v-if="String($_singlySelectedTimelineSegment.data)">
        <span class="flex-grow-1 text-truncate">Data: {{ $_singlySelectedTimelineSegment.data }}</span>
        <text-divider></text-divider>
      </template>
      <span class="text-no-wrap">
        <template v-if="$_singlySelectedTimelineSegment.begin === null">-Inf</template>
        <template v-else>{{ $_singlySelectedTimelineSegment.begin.toFormatString() }}</template>
        <text-divider content="-"></text-divider>
        <template v-if="$_singlySelectedTimelineSegment.end === null">Inf</template>
        <template v-else>{{ $_singlySelectedTimelineSegment.end.toFormatString() }}</template>
      </span>
      <text-divider></text-divider>
    </template>
    <span class="text-no-wrap">
      {{ playTime.toFormatString() }}
    </span>
    <text-divider></text-divider>
    <span class="text-no-wrap link" v-on:click="showDurationEditor">
      {{ timelineViewBeginMin.toFormatString() }}
      <text-divider content="-"></text-divider>
      {{ timelineViewEndMax.toFormatString() }}
    </span>
    <text-divider></text-divider>
    <timeline-view-mode-menu v-bind:view-mode.sync="$_viewMode">
    </timeline-view-mode-menu>
    <text-divider></text-divider>
    <timeline-view-resolution-menu
      v-bind:time-resolution.sync="$_timeResolution"
      v-bind:time-resolution-min="timeResolutionMin"
      v-bind:time-resolution-max="timeResolutionMax"
      v-bind:timeline-position-resolution.sync="$_timelinePositionResolution"
      v-bind:timeline-position-resolution-min="timelinePositionResolutionMin"
      v-bind:timeline-position-resolution-max="timelinePositionResolutionMax"
      v-bind:waveform-scale.sync="$_waveformScale"
      v-bind:waveform-scale-min="waveformScaleMin"
      v-bind:waveform-scale-max="waveformScaleMax"
    >
    </timeline-view-resolution-menu>
  </div>
</template>

<style scoped>
div#timeline-info-bar {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: right;
  height: 20px;
  width: 100%;
  padding: 0 10px;
  font-size: 11px;
  line-height: 11px;
}

span.link {
  cursor: pointer;
}
</style>

<script>
import TextDivider from '../Parts/TextDivider.vue';
import TimelineViewResolutionMenu from './TimelineViewResolutionMenu.vue';
import TimelineViewModeMenu from './TimelineViewModeMenu.vue';
import { TimelineDataSet } from '../../modules/ScattData.js';
import TimeValue from '../../modules/TimeValue.js';

export default {
  components: {
    TextDivider,
    TimelineViewResolutionMenu,
    TimelineViewModeMenu,
  },

  props: {
    timelineViewBeginMin:          { type: TimeValue },
    timelineViewEndMax:            { type: TimeValue },
    playTime:                      { type: TimeValue },
    visibleTimelineDataSet:        { type: TimelineDataSet },
    selectedTimelineSegmentIds:    { type: Array },
    viewMode:                      { type: String },
    timeResolution:                { type: Number },
    timeResolutionMin:             { type: Number },
    timeResolutionMax:             { type: Number },
    timelinePositionResolution:    { type: Number },
    timelinePositionResolutionMin: { type: Number },
    timelinePositionResolutionMax: { type: Number },
    waveformScale:                 { type: Number },
    waveformScaleMin:              { type: Number },
    waveformScaleMax:              { type: Number },
  },

  computed: {
    $_timeResolution: {
      get() { return this.timeResolution },
      set(timeResolution) { this.$emit('update:time-resolution', timeResolution) },
    },

    $_timelinePositionResolution: {
      get() { return this.timelinePositionResolution },
      set(timelinePositionResolution) { this.$emit('update:timeline-position-resolution', timelinePositionResolution) },
    },

    $_waveformScale: {
      get() { return this.waveformScale },
      set(waveformScale) { this.$emit('update:waveform-scale', waveformScale) },
    },

    $_singlySelectedTimelineSegment() {
      if (this.selectedTimelineSegmentIds.length !== 1) return undefined;
      let singlySelectedTimelineSegmentId = this.selectedTimelineSegmentIds[0];
      return this.visibleTimelineDataSet.getSegment(singlySelectedTimelineSegmentId);
    },

    $_viewMode: {
      get()         { return this.viewMode },
      set(viewMode) { this.$emit('update:view-mode', viewMode) },
    },
  },

  inject: [
    'showDurationEditor',
  ],
}
</script>